import { StateContext } from '@ngxs/store';
import { ExhibitionStateModel } from '../exhibition.state';
import { ChangeNote } from '../exhibition.state.actions';

export const changeNote = (ctx: StateContext<ExhibitionStateModel>, action: ChangeNote) => {
    ctx.patchState({
        note: action.payload.note
    });
};
